export const ABOUT_MAX_LENGTH = 2000;
export const MEMBER_NAME_MAX_LENGTH = 32;

/**
 * ユーザー名禁止パターン
 * Unicode homoglyphs（視覚的に似た文字）にも対応
 * - アクセント付き文字（í, ì, î, ï など）
 * - キリル文字（і, с, о など）
 * - ギリシャ文字（ι など）
 */
export const MEMBER_NAME_DENY_PATTERN = new RegExp(
  [
    // iichi のバリエーション（アクセント付き、キリル文字、ギリシャ文字を含む）
    '[iíìîïιіӏ][iíìîïιіӏ][cçćčċс][hĥħн][iíìîïιіӏ]',
    // 全角 iichi
    'ｉｉｃｈｉ',
    // support のバリエーション
    '[sśšşѕ][uúùûüυս][pрρ][pрρ][oóòôõöοо][rŕřяρ][tťţτт]',
    // 全角 support
    'ｓｕｐｐｏｒｔ',
    // 日本語
    'いいち',
    'イイチ',
    'サポート',
  ].join('|'),
  'i',
);

export const Credential = {
  ALCOHOL_SELLER: 'iichi.alcohol_seller',
  BANK_ACCOUNT_REGISTERED: 'iichi.bank_account_registered',
  BUYER: 'iichi.buyer',
  EMAIL_CONFIRMED: 'iichi.email_confirmed',
  FOOD_SELLER: 'iichi.food_seller',
  IICHI_STAFF: 'iichi.iichi_staff',
  PRE_SELLER: 'iichi.pre.seller',
  PROMOTER: 'iichi.promoter',
  SELLER: 'iichi.seller',
  TRADER: 'iichi.trader',
  VINTAGE_SELLER: 'iichi.vintage_seller',
  WMS_INTEGRATED: 'iichi.wms_integrated',
} as const;
export type Credential = (typeof Credential)[keyof typeof Credential];
